import LayoutHome from '@/layout/LayoutHome'

export default [{
  path: '/',
  component: LayoutHome,
  children: [{
    path: 'home',
    component: () => import('@/components/homes/Home')
  },
  {
    path: 'about',
    component: () => import('@/components/homes/About')
  },
  {
    path: 'news',
    component: () => import('@/components/homes/News')
  },
  {
    path: 'post/:id',
    component: () => import('@/components/homes/Post'),
    props: true
  },
  {
    path: 'timetables',
    component: () => import('@/components/homes/TimeTables')
  },
  {
    path: 'contact',
    component: () => import('@/components/homes/Contact')
  }]
}]
